import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useState } from 'react';
import { withPageProviders } from '../../../context/page-context';
import { PartnerGroup } from '../components/partner-group';
import { PARTNER_DOCS_URLS, PARTNERS_I18N } from '../constants';
import { usePartnerCatalogue } from '../hooks/use-partner-catalogue';
import type { Partner } from '../types';

const PAGE = PARTNERS_I18N.page;

export const PartnersPage = withPageProviders(PartnersPageContent);

function PartnersPageContent() {
  const groups = usePartnerCatalogue();
  const [openPartner, setOpenPartner] = useState<Partner | null>(null);

  return (
    <Page
      title={t(`${PAGE}.header.title`)}
      description={t(`${PAGE}.header.description`)}
      learnMoreUrl={PARTNER_DOCS_URLS.learnMore}
    >
      {groups.map((group) => (
        <PartnerGroup key={group.type} group={group} onConfigure={setOpenPartner} />
      ))}
      {openPartner && <openPartner.Modal isOpen onClose={() => setOpenPartner(null)} />}
    </Page>
  );
}
